// Show popup only once per session
document.addEventListener("DOMContentLoaded", function () {
  if (!sessionStorage.getItem("ageVerified")) {
    const popup = document.getElementById("age-popup");
    const checkbox = document.getElementById("age-confirm");
    const enterBtn = document.getElementById("age-enter");
    
    popup.style.display = "flex";

    // Show/hide Enter button based on checkbox
    checkbox.addEventListener("change", function () {
      if (this.checked) {
        enterBtn.style.display = "block";
      } else {
        enterBtn.style.display = "none";
      }
    });

    // Handle Enter button click
    enterBtn.addEventListener("click", function () {
      sessionStorage.setItem("ageVerified", "true");
      popup.style.display = "none";
    });
  }
});